import { createSlice } from "@reduxjs/toolkit";
import { sanitizeClientData } from "./client_reducer.js";

// creating reducer with initial value
export const staffReducer = createSlice({
    name: "staff_store",

    initialState: {
        isAuthenticated: false,
        accessType: "STAFF_ACCESS",
        activeStaff: {},
        staffDB: {},
        sessionToken: null,

        dashboard: {
            nav_title: "Dashboard",
            nav_trace: "dashboard",
            subNavBar_title: "",
            subNavBar_trace: "dashboard",
            toggleNavDropdown: "",
            currentTab: "",
        },
    },

    reducers: {
        startStaffAction: (state, action) => {
            const { staffPayload, authenticationType, sessionToken } =
                action.payload;

            const safeStaffPayload = sanitizeClientData(staffPayload);

            return {
                ...state,

                staffDB: safeStaffPayload || {},

                activeStaff: safeStaffPayload?.staffData || {},

                isAuthenticated: true,

                accessType: authenticationType || "STAFF_ACCESS",

                sessionToken: sessionToken || null,

                dashboard: {
                    ...state.dashboard,

                    nav_title: "Dashboard",
                    nav_trace: "dashboard",
                    subNavBar_title: "",
                    subNavBar_trace: "dashboard",
                    toggleNavDropdown: "",
                    currentTab: "",
                },
            };
        },

        staffLogOut: (state, action) => {
            return {
                ...state,

                staffDB: {},

                isAuthenticated: false,

                accessType: "",

                activeStaff: {},

                sessionToken: null,
            };
        },
    },
});

export const { startStaffAction, staffLogOut } = staffReducer.actions;

export default staffReducer.reducer;
